import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'form-email-field',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {




const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createBlock(_component_a_form_item, {
    class: "form-email-field stc-ant-field-skin",
    label: "Почта",
    name: "email",
    required: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        class: "form-email-field__input",
        type: "email",
        value: __props.modelValue,
        placeholder: "example@mail.ru",
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})